export class BaseRequests {
  static getUrlSearch(baseUrl, paramsObj) {
    const paramsURL = new URLSearchParams();
    for (const [key, value] of Object.entries(paramsObj)) {
      if (value !== null && value !== undefined) { paramsURL.append(key, Array.isArray(value) ? JSON.stringify(value) : value.toString()); }
    }
    const urlWithParams = !![...paramsURL].length ? `${baseUrl}?${paramsURL.toString().replaceAll(/%2F/ig, '/')}` : baseUrl;
    return urlWithParams;
  }

  static getNavigationLinks(respProject,navProject){
    if (respProject.strategy?.type === 'strategy') navProject.setStratTitle(respProject.strategy.name);
    else navProject.setPolicyTitle(respProject.strategy.name);
    // портфель или без портфеля
    if (respProject.portfolio) {
      navProject.setPortfolioTitle(respProject.portfolio.name);
      navProject.setPortfProjTitle(respProject.name);
    } else navProject.setProjTitle(respProject.name);
  }
}


